import styled from 'styled-components';

export default styled.hr`
  margin: 36px 0px;
  background-color: rgba(155, 155, 155, 0.49);
  height: 2px;
  @media(max-width: 700px) {
    margin: 25px 0px;
  }
`;
